// ============================================================
// EVENT DELEGATION — replaces all inline onclick handlers
// ============================================================
// Uses data-action attributes on HTML elements to dispatch
// click events to the correct handler functions.
// This is CSP-friendly (no 'unsafe-inline' needed for handlers).
// ============================================================

(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    // Handle clicks directly on video elements (pause/play toggle)
    if (e.target.tagName === 'VIDEO') {
      var v = e.target;
      var wrap = v.closest('.video-wrap') || v.closest('.vc-slide');
      var btn = wrap ? wrap.querySelector('.play-btn, .vc-play') : null;
      if (v.paused) {
        // Pause all others first
        document.querySelectorAll('video').forEach(function(ov) {
          if (ov !== v && !ov.paused) {
            ov.pause();
            var ob = (ov.closest('.video-wrap') || ov.closest('.vc-slide') || ov.parentElement).querySelector('.play-btn, .vc-play');
            if (ob) ob.style.display = 'flex';
          }
        });
        v.play();
        if (btn) btn.style.display = 'none';
      } else {
        v.pause();
        if (btn) btn.style.display = 'flex';
      }
      return;
    }

    var el = e.target.closest('[data-action]');
    if (!el) return;

    var action = el.getAttribute('data-action');

    switch (action) {

      // ---- Accordions ----
      case 'toggleAcc':
        var accItem = el.closest('.accordion-item') || el.closest('.step-acc-item');
        if (accItem) accItem.classList.toggle('open');
        break;

      case 'toggleProdAcc':
        var prodAcc = el.closest('.prod-acc');
        if (prodAcc) prodAcc.classList.toggle('open');
        break;

      case 'toggleParent':
        el.parentElement.classList.toggle('open');
        break;

      // ---- Navigation / Scroll ----
      case 'scrollToBuy':
        if (typeof scrollToBuy === 'function') scrollToBuy();
        break;

      // ---- Cart ----
      case 'addToCartAction':
        if (typeof addToCartAction === 'function') addToCartAction();
        break;

      case 'toggleSubscribe':
        if (typeof toggleSubscribe === 'function') toggleSubscribe();
        break;

      // ---- Gallery ----
      case 'goToGallery':
        var idx = parseInt(el.getAttribute('data-idx'));
        if (typeof goToGallery === 'function' && !isNaN(idx)) goToGallery(idx);
        break;

      case 'slideGallery':
        var dir = parseInt(el.getAttribute('data-dir'));
        if (typeof slideGallery === 'function' && !isNaN(dir)) slideGallery(dir);
        break;

      case 'scrollThumbs':
        var thumbDir = parseInt(el.getAttribute('data-dir'));
        if (typeof scrollThumbs === 'function' && !isNaN(thumbDir)) scrollThumbs(thumbDir);
        break;

      // ---- Video ----
      case 'playVideo':
        var wrap = el.closest('.video-wrap') || el;
        var vSrc = wrap.getAttribute('data-video');
        if (!vSrc) break;
        var vPlayBtn = wrap.querySelector('.play-btn');
        var vExisting = wrap.querySelector('video');
        if (vExisting) {
          if (vExisting.paused) {
            document.querySelectorAll('.video-wrap video').forEach(function(v) {
              if (v !== vExisting && !v.paused) { v.pause(); var b = v.parentElement.querySelector('.play-btn'); if (b) b.style.display = 'flex'; }
            });
            vExisting.play();
            if (vPlayBtn) vPlayBtn.style.display = 'none';
          } else {
            vExisting.pause();
            if (vPlayBtn) vPlayBtn.style.display = 'flex';
          }
        } else {
          document.querySelectorAll('.video-wrap video').forEach(function(v) {
            v.pause(); var b = v.parentElement.querySelector('.play-btn'); if (b) b.style.display = 'flex';
          });
          var vid = document.createElement('video');
          vid.src = vSrc; vid.playsInline = true; vid.autoplay = true;
          vid.style.cssText = 'width:100%;height:100%;object-fit:cover;position:absolute;top:0;left:0;cursor:pointer';
          vid.addEventListener('ended', function() { if (vPlayBtn) vPlayBtn.style.display = 'flex'; });
          var vImg = wrap.querySelector('img');
          if (vImg) vImg.style.display = 'none';
          if (vPlayBtn) vPlayBtn.style.display = 'none';
          wrap.appendChild(vid);
        }
        break;

      // ---- Reviews ----
      case 'expandReview':
        if (typeof expandReview === 'function') expandReview(el);
        break;

      case 'sortReviews':
        var mode = el.getAttribute('data-mode');
        if (typeof sortReviews === 'function' && mode) sortReviews(mode);
        break;

      case 'loadMoreReviews':
        if (typeof loadMoreReviews === 'function') loadMoreReviews();
        break;

      case 'setRating':
        var rating = parseInt(el.getAttribute('data-rating'));
        if (typeof setRating === 'function' && !isNaN(rating)) setRating(rating);
        break;

      case 'submitReview':
        if (typeof submitReview === 'function') submitReview();
        break;

      case 'toggleReviewForm':
        var formWrap = document.getElementById('rvFormWrap');
        var writeBtn = document.querySelector('.rv-write-btn');
        if (formWrap) {
          formWrap.classList.toggle('open');
          if (writeBtn) writeBtn.style.display = formWrap.classList.contains('open') ? 'none' : '';
        }
        break;

      case 'triggerFileInput':
        var fileInput = document.getElementById('rvFileInput');
        if (fileInput) fileInput.click();
        break;

      case 'toggleSortMenu':
        var sortMenu = document.getElementById('rvSortMenu');
        if (sortMenu) sortMenu.classList.toggle('rv-hidden');
        break;

      // ---- Lander Videos (lazy-loaded) ----
      case 'playLanderVid':
        var vidIdx = parseInt(el.getAttribute('data-idx'));
        var vidEl = document.getElementById('vid' + vidIdx);
        if (!vidEl) break;
        var landerBtn = el;
        // Lazy-load src on first play
        if (!vidEl.src && vidEl.dataset.src) {
          vidEl.src = vidEl.dataset.src;
        }
        // Pause all other videos
        ['vid0','vid1','vid2'].forEach(function(id) {
          var v = document.getElementById(id);
          if (v && v !== vidEl && !v.paused) {
            v.pause();
            var b = v.parentElement.querySelector('.vc-play');
            if (b) b.style.display = 'flex';
          }
        });
        if (vidEl.paused) {
          vidEl.play();
          landerBtn.style.display = 'none';
        } else {
          vidEl.pause();
          landerBtn.style.display = 'flex';
        }
        // Re-show play btn on end
        vidEl.onended = function() { landerBtn.style.display = 'flex'; };
        break;
    }
  });

  // Also handle click on the video element itself for pause/play
  document.addEventListener('click', function(e) {
    if (e.target.tagName === 'VIDEO' && e.target.id && e.target.id.match(/^vid\d$/)) {
      var v = e.target;
      var btn = v.parentElement.querySelector('.vc-play');
      if (!v.paused) {
        v.pause();
        if (btn) btn.style.display = 'flex';
      } else {
        v.play();
        if (btn) btn.style.display = 'none';
      }
    }
  });
})();
